export default __webpack_public_path__ + "static/media/win.902cc225.wav";